import * as React from 'react';

import { PropertyAwardsAndAffiliationsViewModel } from 'models';

import { PropertyDetailsSegment } from './property-details-segment';

interface AwardsAndAffliationsProps {
  propertyAwardsAndAffiliations?: PropertyAwardsAndAffiliationsViewModel;
}

export const AwardsAndAffiliations: React.FunctionComponent<AwardsAndAffliationsProps> = ({ propertyAwardsAndAffiliations }) =>
  Boolean(propertyAwardsAndAffiliations) &&
  Boolean(propertyAwardsAndAffiliations.awardsAndAffiliations) &&
  propertyAwardsAndAffiliations.awardsAndAffiliations.length > 0 && (
    <PropertyDetailsSegment
      dataStid="section-awards-and-affiliations"
      errorBoundaryLabel="hotel.information.details.awardsAndAffiliations"
      rootClassName="awards-and-affiliations"
      title={propertyAwardsAndAffiliations.title}
      isToggleHidden={true}
    >
      {propertyAwardsAndAffiliations.awardsAndAffiliations.map((awardsAndAffiliations, idx) => (
        <div
          key={`awards-and-affiliations-${idx}`}
          className="all-y-padding-three uitk-type-list-300"
          dangerouslySetInnerHTML={{ __html: awardsAndAffiliations.text }}
        />
      ))}
    </PropertyDetailsSegment>
  );
